import { Box, Typography } from '@mui/material';
import { BaseAssetProps } from '../types';
import { AssetWrapper } from '../assetWrapper/AssetWrapper';
import { useAuthentication } from 'src/features/authentication/context';
import { useGetAssetByIdQuery } from 'src/hooks/reactQueryApiHooks';
import { useWaterData } from 'src/hooks/featureHooks';
import { TowerIcon } from 'src/assets/icons/TowerIcon';
import { AssetNameLabel } from '../../assetNameLabel/AssetNameLabel';

type Props = BaseAssetProps;

export const Tower = ({ selected, width, height, data, id }: Props) => {
  const widthOfElement = width ? width : 370;
  const heightOfElement = height ? height : 380;

  const tankTop = heightOfElement * 0.02;
  const tankLeft = widthOfElement * 0.275;
  const tankWidth = widthOfElement * 0.45;
  const tankHeight = heightOfElement * 0.38;

  const {
    customerId: { value: customerId },
  } = useAuthentication();

  const { asset } = useGetAssetByIdQuery({
    customerId: customerId!,
    siteId: data?.siteId,
    assetId: data?.assetId,
  });
  const { waterLevel, unit } = useWaterData({ asset });

  const waterHeightPx = ((waterLevel ?? 0) / 100) * tankHeight;
  const labelBottom = Math.min(waterHeightPx, tankHeight - 58);

  return (
    <AssetWrapper selected={selected} width={widthOfElement} height={heightOfElement} id={id}>
      <Box style={{ position: 'relative', width: '100%', height: '100%' }} data-sm="towe-widget">
        <TowerIcon width={width} height={heightOfElement} />

        <Box
          style={{
            position: 'absolute',
            top: tankTop,
            left: tankLeft,
            width: tankWidth,
            height: tankHeight,
            borderRadius: tankWidth * 0.28,
            overflow: 'hidden',
            background: '#f4f4f7',
          }}
        >
          <Box
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: `${waterHeightPx}px`,
              backgroundColor: '#cbdef7',
              transition: 'height 0.3s ease',
              overflow: 'hidden',
              borderTopLeftRadius: waterLevel === 100 ? tankWidth * 0.28 : 0,
              borderTopRightRadius: waterLevel === 100 ? tankWidth * 0.28 : 0,
            }}
          />
          {waterLevel !== null && (
            <Typography
              data-sm="water-tower-value"
              variant="caption"
              style={{
                position: 'absolute',
                bottom: `${labelBottom}px`,
                left: '50%',
                transform: 'translateX(-50%)',
                padding: '1px 4px',
                borderRadius: 4,
                fontWeight: 500,
                fontSize: `${Math.max(widthOfElement, heightOfElement) * 0.035}px`,
                textAlign: 'center',
              }}
            >
              {waterLevel} {unit}
            </Typography>
          )}
        </Box>
        {data?.isDisplayName && (
          <AssetNameLabel
            assetName={asset?.assetName}
            widthOfElement={widthOfElement}
            heightOfElement={heightOfElement}
          />
        )}
      </Box>
    </AssetWrapper>
  );
};
